import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-width": "1.5",
  "stroke-miterlimit": "10",
  d: "M17.3 23c-.1 0-.2 0-.3-.1L6.4 12.3c-.2-.2-.2-.5 0-.7L16.9 1.1c.2-.2.5-.2.7 0 .2.2.2.5 0 .7 0 0 0 0 0 0L7.4 12l10.2 10.2c.2.2.2.5 0 .7-.1 0-.2.1-.3.1z"
}, null, -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-width": "1.5",
  "stroke-miterlimit": "10",
  d: "M17.3 23c-.1 0-.2 0-.3-.1L6.4 12.3c-.2-.2-.2-.5 0-.7L16.9 1.1c.2-.2.5-.2.7 0 .2.2.2.5 0 .7 0 0 0 0 0 0L7.4 12l10.2 10.2c.2.2.2.5 0 .7-.1 0-.2.1-.3.1z"
}, null, -1 /* HOISTED */)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }